import ActivityCalendarModule from './containers/activityCalendarModule'

export {default as ActivityCalendarModuleLayout} from './components/activityCalendarModuleLayout'

export default ActivityCalendarModule
